import * as React from 'react';

import moment, { Moment } from 'moment';
import { Toggle, FroalaInput } from '../../react-common';
import { DatePicker, TimePicker } from '../../react-common/Pickers';

// Localizer for DateTimePicker
moment.locale('en');

type AnnouncementEditState = {
  delay?: Date;
  subject: string;
  replyTo: string;
  sendLater: boolean;
  body: string;
  datePickerValue: string;
  timePickerValue: string;
  [x: string]: string | boolean | Date;
};

class AnnouncementEdit extends React.Component<any, AnnouncementEditState> {
  constructor(props: any) {
    super(props);
    const { announcement = {} } = props;
    this.state = {
      subject: '',
      replyTo: '',
      sendLater: false,
      body: '',
      ...announcement,
    };
  }

  onFieldChange =
    (field: 'replyTo' | 'subject' | 'sendLater') =>
    (event: React.FormEvent<HTMLInputElement>) => {
      const { value, checked, type } = event.currentTarget;
      const { onChange } = this.props;
      this.setState({ [field]: type === 'checkbox' ? checked : value }, () =>
        onChange(this.state),
      );
    };

  toggleSendLater = (event: React.MouseEvent) => {
    event.stopPropagation();
    const { sendLater } = this.state;
    const { onChange } = this.props;
    this.setState({ sendLater: !sendLater }, () => onChange(this.state));
  };

  onDateChange = (date: Moment, value: string) => {
    const { onChange } = this.props;
    const day = moment(date).dayOfYear();
    this.setState(
      {
        datePickerValue: value,
        delay: moment(date).dayOfYear(day).seconds(0).toDate(),
      },
      () => onChange(this.state),
    );
  };

  onTimeChange = (time: Moment, value: string) => {
    const { onChange } = this.props;
    const { delay = new Date() } = this.state;
    const hour = moment(time).hours();
    const min = moment(time).minutes();
    this.setState(
      {
        timePickerValue: value,
        delay: moment(delay).hours(hour).minutes(min).seconds(0).toDate(),
      },
      () => onChange(this.state),
    );
  };

  onFroalaChange = (body: string) => {
    const { onChange } = this.props;
    this.setState({ body }, () => onChange(this.state));
  };

  render() {
    const {
      delay,
      sendLater,
      subject,
      replyTo,
      body,
      timePickerValue,
      datePickerValue,
    } = this.state;
    return (
      <div className="announcement-edit-container">
        <form>
          <div className="form-group">
            <label>Reply-To:</label>
            <input
              value={replyTo}
              onChange={this.onFieldChange('replyTo')}
              className="form-control"
              type="text"
            ></input>
          </div>
          <div className="form-group">
            <label>Subject:</label>
            <input
              value={subject}
              onChange={this.onFieldChange('subject')}
              className="form-control"
              type="text"
            ></input>
          </div>
        </form>
        <form>
          <div className="form-group">
            <label>Schedule - Send Later:</label>
            <div style={{ height: 34, display: 'flex', alignItems: 'center' }}>
              <Toggle
                model={sendLater}
                onClick={this.toggleSendLater}
                onChange={this.onFieldChange('sendLater')}
              />
            </div>
          </div>
          {sendLater && (
            <div className="form-group">
              <label>Send On:</label>
              <div className="date-time-container">
                <div>
                  <DatePicker
                    inputValue={datePickerValue}
                    inputVariant="outlined"
                    value={delay}
                    onChange={this.onDateChange}
                    format="YYYY-MM-DD"
                    variant="inline"
                    autoOk
                    disablePast
                  />
                </div>
                <div>
                  <TimePicker
                    inputValue={timePickerValue}
                    value={delay}
                    onChange={this.onTimeChange}
                    inputVariant="outlined"
                    mask="__:__ _M"
                    variant="inline"
                    autoOk
                  />
                </div>
              </div>
            </div>
          )}
        </form>

        <div className="froala-container">
          <FroalaInput
            onModelChange={this.onFroalaChange}
            model={body}
            config={{
              pluginsEnabled: ['url'],
              toolbarButtons: {
                moreRich: {
                  buttons: [
                    'insertLink',
                    'insertImage',
                    'insertFile',
                    'insertVideo',
                    'insertHR',
                  ],
                },
              },
            }}
          />
        </div>
      </div>
    );
  }
}

export default AnnouncementEdit;
